import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Layers, MessageSquare, Package } from "lucide-react";
import SmartImage from "./SmartImage";
import { enquireHref, pageHref } from "../lib/format";

/**
 * Auto-generated category grid. The old site's hub pages were menu-only with an
 * empty body, so we build a real landing grid from their child pages.
 */
export default function HubGrid({ items = [], parentLabel }) {
  if (!items.length) return null;

  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="hub-category-grid">
      {items.map((c, i) => {
        const feature = i < 2 && items.length > 3;
        return (
          <article
            key={c.slug}
            className={`card-nq group flex flex-col ${feature ? "sm:col-span-1" : ""}`}
            data-testid="hub-category-card"
          >
            <Link to={pageHref(c.slug)} className="block overflow-hidden">
              <SmartImage
                src={c.image}
                alt={c.label}
                ratio={feature ? "aspect-[16/10]" : "aspect-[16/10]"}
                fit="contain"
                fallbackLabel={c.label}
                className="transition-transform duration-500 group-hover:scale-[1.04]"
              />
            </Link>

            <div className="flex flex-1 flex-col p-5">
              <h3 className="text-lg font-semibold text-[color:var(--nq-sand)]">
                <Link to={pageHref(c.slug)} className="transition hover:text-[color:var(--nq-gold)]">
                  {c.label}
                </Link>
              </h3>

              {c.excerpt && (
                <p className="mt-2 line-clamp-3 text-sm text-[color:var(--nq-stone)]">{c.excerpt}</p>
              )}

              <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-[color:var(--nq-stone)]">
                {c.child_count > 0 && (
                  <span className="flex items-center gap-1.5">
                    <Layers className="h-3.5 w-3.5 gold-text" /> {c.child_count} sub-categories
                  </span>
                )}
                {c.item_count > 0 && (
                  <span className="flex items-center gap-1.5">
                    <Package className="h-3.5 w-3.5 gold-text" /> {c.item_count} products
                  </span>
                )}
              </div>

              <div className="mt-auto flex gap-2 pt-4">
                <Link
                  to={pageHref(c.slug)}
                  className="btn-outline-nq flex-1 px-3 py-2 text-xs"
                  data-testid="hub-card-view-cta"
                >
                  View range <ArrowRight className="h-3.5 w-3.5" />
                </Link>
                <Link
                  to={enquireHref({
                    type: "page",
                    id: c.slug,
                    title: c.label,
                    image: c.image,
                    category: parentLabel,
                  })}
                  className="btn-gold px-3 py-2 text-xs"
                  data-testid="hub-card-enquire-cta"
                >
                  <MessageSquare className="h-3.5 w-3.5" />
                </Link>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}
